import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { CommonService } from '@tech-services/common.service';
import { Subscription, timer, Subject } from 'rxjs';
import { UntypedFormControl, Validators } from '@angular/forms';
import { PortfolioanalysisSumaryInterface } from '@techrules/portallib';
/*import { PortfolioDataInterface } from '@tech-interfaces/portfolio-data.interface';*/
import { PortfolioDataInterface } from '@techrules/portallib';
import { formatDate } from '@angular/common';
import { SessionService } from '@tech-services/session.service';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';
import { ModalCustomDateComponent } from 'projects/apps/portal-client/src/app/shared/modal-custom-date/modal-custom-date.component';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'tech-portfolio-sumary',
  templateUrl: './portfolio-sumary.component.html',
  styleUrls: ['./portfolio-sumary.component.scss'],
})
export class PortfolioSumaryComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private timer50 = timer(50);
  private timer2seg = timer(2000);
  private timer3seg = timer(3000);
  private updateAliasPortfolioSubcription: Subscription;

  faCircleInfo = faCircleInfo;

  loaddingSummary: boolean = true;
  portfolioname: string;
  editPortfolioName = false;
  periodInitialDate: string = '';
  periodEndDate: string = '';
  riskLevel: string;
  volatility: number;
  currency: string;
  valuationinitialdate: number;
  contributions: number;
  withdrawals: number;
  totalprofitLossbeetweendates: number;
  lastwek: number;
  year1: number;
  month1: number;
  month3: number;
  years3: number;
  years5: number;
  ydt: number;
  all: number;
  valuationenddate: number;
  minDate: string = '';
  maxDate: string = '';
  language = this.sessionService.language;
  dateFormat = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');
  portfolioanalysis: PortfolioanalysisSumaryInterface;
  portfoliodata: PortfolioDataInterface;
  option1: boolean;
  @ViewChild('inputNamePortfolio', { static: false })
  inputNamePortfolio: any;
  portfolionameFormControl = new UntypedFormControl('', [Validators.required]);
  LiabilitiesValuation: number;
  HasCredits: boolean;
  public performaceProfitLossTitle: string;
  public showProfitLossInClientPortal: boolean = false;
  constructor(
    public profilePortfolioService: ProfileportfolioService,
    private sessionService: SessionService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.profilePortfolioService.portfolioData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (data) {
          // console.log(data);
          this.option1 = data.ServiceModelCode !== 'RO';
          this.profilePortfolioService.loadingRiskValuations = false;
          this.portfoliodata = data;
          // this.profilePortfolioService.portfolioDataSource.next(data);
          this.riskLevel = this.portfoliodata.RiskLevel;
          this.volatility = this.portfoliodata.Volatility;
          //Load minDate and maxDate with portfolio date limits
          this.minDate = this.portfoliodata.InitialDate;
          this.maxDate = this.portfoliodata.AnalysisDate;
        }
      });

    this.profilePortfolioService.fixedPeriods$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        data.forEach((period) => {
          if (period.Period === 'PeriodStartDate') {
            this.periodInitialDate = period.PeriodInitialtDate;
            this.periodEndDate = period.PeriodEndDate;
            this.minDate = period.PeriodInitialtDate;
            this.maxDate = period.PeriodEndDate;
          }
        });
      });

    this.profilePortfolioService.portfolioanalysis$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((val) => {
        this.profilePortfolioService.loadingRiskValuations = false;
        this.portfolioanalysis = val;
        this.HasCredits =
          this.profilePortfolioService.portfolioAnalysisHasCreditsSource.getValue();
        setTimeout(() => {
          this.loadSumaryData();
        });
        this.profilePortfolioService.periodSelected$
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((res) => {
            if (res) {
              if (res.Period != 'PeriodCustom') {
                this.periodInitialDate = res.PeriodInitialtDate;
                this.periodEndDate = res.PeriodEndDate;
              }
            }
          });
      });

  }

  ngAfterContentInit() {}

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  loadSumaryData() {
    if (
      Object.keys(
        this.profilePortfolioService.portfolioanalysisSource.getValue()
      ).length !== 0
    ) {
      this.loaddingSummary = false;
      this.currency =
        this.profilePortfolioService.portfolioanalysisSource.getValue().Currency;
      this.valuationinitialdate =
        this.profilePortfolioService.portfolioanalysisSource.getValue().ValuationInitialDate;
      this.contributions =
        this.profilePortfolioService.portfolioanalysisSource.getValue().Contributions;
      this.withdrawals =
        this.profilePortfolioService.portfolioanalysisSource.getValue().Withdrawals;
      this.totalprofitLossbeetweendates =
        this.profilePortfolioService.portfolioanalysisSource.getValue().TotalProfitLossBeetweenDates;
      this.valuationenddate =
        this.profilePortfolioService.portfolioanalysisSource.getValue().ValuationEndDate;
      this.showProfitLossInClientPortal = this.profilePortfolioService.portfolioanalysisSource.getValue().ShowProfitLossInClientPortal
      if(this.profilePortfolioService.portfolioanalysisSource.getValue().ShowProfitLossInClientPortal){
        this.translate.get('k004391').subscribe((text) => {
          // Token: Total gain/loss
          this.performaceProfitLossTitle = text;
        });
        this.lastwek =
          this.profilePortfolioService.portfolioanalysisSource.getValue().ProfitLossData[0].ProfitLossLastWeek;
        this.year1 =
          this.profilePortfolioService.portfolioanalysisSource.getValue().ProfitLossData[0].ProfitLoss1Y;
        this.month1 =
          this.profilePortfolioService.portfolioanalysisSource.getValue().ProfitLossData[0].ProfitLoss1M;
        this.ydt =
          this.profilePortfolioService.portfolioanalysisSource.getValue().ProfitLossData[0].ProfitLossYTD;
        this.all =
          this.profilePortfolioService.portfolioanalysisSource.getValue().ProfitLossData[0].ProfitLossStartDate;
        this.periodInitialDate =
          this.profilePortfolioService.periodSelectedSource.getValue().PeriodInitialtDate;
        this.periodEndDate =
          this.profilePortfolioService.periodSelectedSource.getValue().PeriodEndDate;
      }else{
        this.translate.get('k002917').subscribe((text) => {
          // Token: Total performance
          this.performaceProfitLossTitle = text;
        });
        this.lastwek =
          this.profilePortfolioService.portfolioanalysisSource.getValue().PerformanceData[0].Performance1W;
        this.year1 =
          this.profilePortfolioService.portfolioanalysisSource.getValue().PerformanceData[0].Performance1Y;
        this.month1 =
          this.profilePortfolioService.portfolioanalysisSource.getValue().PerformanceData[0].Performance1M;
        this.ydt =
          this.profilePortfolioService.portfolioanalysisSource.getValue().PerformanceData[0].PerformanceYTD;
        this.all =
          this.profilePortfolioService.portfolioanalysisSource.getValue().PerformanceData[0].PerformanceStartDate;
        this.periodInitialDate =
          this.profilePortfolioService.periodSelectedSource.getValue().PeriodInitialtDate;
        this.periodEndDate =
          this.profilePortfolioService.periodSelectedSource.getValue().PeriodEndDate;
      }
      if (
        this.profilePortfolioService.portfolioanalysisSource.getValue().Alias !=
        ''
      ) {
        this.portfolioname =
          this.profilePortfolioService.portfolioanalysisSource.getValue().Alias;
      } else {
        this.portfolioname =
          this.profilePortfolioService.portfolioanalysisSource.getValue().Name;
      }
      if (
        this.profilePortfolioService.portfolioDataSource.getValue() != undefined
      ) {
        this.riskLevel =
          this.profilePortfolioService.portfolioDataSource.getValue().RiskLevel;
        this.volatility =
          this.profilePortfolioService.portfolioDataSource.getValue().Volatility;
      }
      if (
        this.profilePortfolioService.portfolioanalysisSource.getValue()
          .LiabilitiesValuation
      ) {
        this.LiabilitiesValuation =
          this.profilePortfolioService.portfolioanalysisSource.getValue().LiabilitiesValuation;
      }
    }
  }

  editPortfolioNameClick(event) {
    this.editPortfolioName = true;
    setTimeout(() => {
      this.inputNamePortfolio.nativeElement.value = this.portfolioname;
      this.inputNamePortfolio.nativeElement.focus();
    }, 0);
  }

  blurPortfolioName(event) {
    if (this.portfolionameFormControl.pristine) {
      this.editPortfolioName = false;
      this.portfolionameFormControl.reset();
    } else if (!this.portfolionameFormControl.hasError('required')) {
      this.editPortfolioName = false;
      this.profilePortfolioService
        .updateAliasPortfolio(event.target.value)
        .subscribe((result) => {
          this.profilePortfolioService.porfolionameSource.next(
            event.target.value
          );
          this.portfolioname = event.target.value;
          //Muestra snackBar informativo
          let verticalPosition: MatSnackBarVerticalPosition =
            this.commonService.isMovilSource.getValue() ? 'top' : 'bottom';
          let message;
          this.translate.get('k002192').subscribe((text) => {
            message = text + ' ' + event.target.value; //Token: The name has been changed to
          });
          this.snackBar.open(message, 'X', {
            data: {
              html: message,
            },
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: verticalPosition,
          });
          this.profilePortfolioService.portfolioanalysisSource.getValue().Alias =
            event.target.value;
          this.profilePortfolioService.portfolioanalysisSource.next(
            this.profilePortfolioService.portfolioanalysisSource.getValue()
          );
          this.portfolionameFormControl.reset();
        });
    }
  }

  openDialog(PeriodInitialDate, PeriodEndDate) {
    const dialogRef = this.dialog.open(ModalCustomDateComponent, {
      data: {
        initialDate: PeriodInitialDate,
        endDate: PeriodEndDate,
        minDate: this.minDate,
        maxDate: this.maxDate,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let customPeriod = {
          Name: 'Personalizado',
          Period: 'PeriodCustomOK',
          PeriodEndDate: formatDate(result.endDate, 'yyyy-MM-dd', 'en_GR'),
          PeriodInitialtDate: formatDate(
            result.initialDate,
            'yyyy-MM-dd',
            'en_GR'
          ),
        };
        this.profilePortfolioService.periodSelectedSource.next(customPeriod);
      }
    });
  }
}
